import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { Breakpoint, FontWeight } from '../../../styles/constants';
import { propSwitch } from '../../../util/propSwitch';
import { Heading } from '../../Typography/Heading/Heading';
import { DisplayCardImagePosition } from './DisplayCard';

export interface StyledDisplayCardProps {
  flat?: boolean;
  imagePosition?: DisplayCardImagePosition;
  link?: string;
}

export const StyledDisplayCard = styled.div<StyledDisplayCardProps>`
  background-color: ${ThemeColours.white};
  border: 1px solid ${ThemeColours.mono200};
  border-radius: 8px;
  box-shadow: ${propSwitch('flat', 'none', '0px 1px 2px rgba(7, 35, 38, 0.1)')};
  color: unset;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  text-decoration: none;

  &:hover {
    box-shadow: ${propSwitch('link', '0 1px 10px 0 rgb(92,119,131, 0.3)', 'none')};
  }

  transition: box-shadow 0.3s;

  ${Breakpoint.MEDIUM} {
    flex-direction: ${({ imagePosition }) => (imagePosition === 'left' ? 'row' : 'row-reverse')};
  }
`;

export const DisplayCardContainer = styled.div<{ compact?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${propSwitch('compact', '24px', '32px')};

  ${Breakpoint.MEDIUM} {
    padding: ${propSwitch('compact', '24px', '50px')};
  }
`;

export const DisplayCardHeader = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 14px;
`;

export const DisplayCardTitle = styled(Heading)`
  font-weight: ${FontWeight.BOLD};
  margin-bottom: 0;
  margin-left: 12px;
`;

export const DisplayCardSubTitle = styled.div`
  color: ${ThemeColours.mono600};
  margin: 0 10px;
`;

export const DisplayCardFooter = styled.div`
  display: flex;
  margin-top: auto;
  padding-top: 12px;
`;

export const DisplayCardContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const DisplayCardBadge = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`;
